import React from 'react';
import {observer} from "mobx-react";
import {useMediaQuery} from "@mui/material";

interface Props {
  desktop: () => React.ReactNode;
  mobile?: () => React.ReactNode;
  tablet?: () => React.ReactNode;
}

export const ResponsiveVariants = observer((props: Props) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(min-width:601px) and (max-width:960px)');
  return <>{isMobile ? props.mobile?.() : (isTablet && props.tablet) ? props.tablet() : props.desktop()}</>;
});